// @flow
import type { Styles } from './types';

const styles: Styles = theme => ({
  root: {},
  drawerHeading: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  icon: {},
  menuLinks: {
    display: 'flex',
    flexDirection: 'column',
    '&:not(:last-child)': {
      paddingBottom: theme.spacing(2),
    },
  },
});

export default styles;
